import MainLayout from '@/pages/Layout/MainLayout.vue'

const Categories = () => import('@/pages/admin/Categories.vue')
const Compositions = () => import('@/pages/admin/compositions/CompositionsList.vue')
const CompositionCategories = () => import('@/pages/admin/compositions/CompositionCategories.vue')

const Distribution = () => import('@/pages/admin/distribution/Distribution.vue')
const Distributed = () => import('@/pages/admin/distribution/Distributed.vue')
const History = () => import('@/pages/admin/distribution/History.vue')
const DistributionTest = () => import('@/pages/admin/DistributionTest.vue')
const StatJudgeCategory = () => import('@/pages/admin/StatJudgeCategory.vue')

const Judges = () => import('@/pages/admin/judges/Judges.vue')
const JudgeDetail = () => import('@/pages/admin/judges/JudgeDetail.vue')
const JudgeCategories = () => import('@/pages/admin/judges/JudgeCategories.vue')
const CompositionsJudge = () => import('@/pages/admin/judges/CompositionsJudge.vue')

const UsersList = () => import('@/pages/admin/users/List.vue')
const UsersDetail = () => import('@/pages/admin/users/Detail.vue')
const Court = () => import('@/pages/admin/Court.vue')

const Organizations = () => import('@/pages/admin/datarequests/Organizations.vue')
const OrgTemplate = () => import('@/pages/admin/datarequests/OrgTemplate.vue')

const ExpertPage = () => import('@/pages/admin/expert/ExpertPage.vue')
const ExpertRegions = () => import('@/pages/admin/expert/ExpertRegions.vue')
const ExpertCourts = () => import('@/pages/admin/expert/ExpertCourts.vue')

const QrCodeLogsPage = () => import('@/pages/admin/expert/QrCodeLogsPage.vue')


export default {
  path: '/admin',
  redirect: '/post/distribution',
  component: MainLayout,
  children: [
    {
      path: 'court',
      component: Court
    },
    {
      path: 'categories',
      component: Categories
    },
    {
      path: 'group',
      component: Compositions
    },
    {
      path: 'group/:groupId',
      component: CompositionCategories,
      props: true
    },
    {
      path: 'distribution',
      component: Distribution
    },
    {
      path: 'distributed',
      component: Distributed
    },
    {
      path: 'history',
      component: History
    },
    {
      path: 'distribtest',
      component: DistributionTest
    },
    {
      path: 'statistic',
      component: StatJudgeCategory
    },
    {
      path: 'judges',
      component: Judges
    },
    {
      path: 'judges/:judgeId',
      name: 'JudgeDetail',
      component: JudgeDetail,
      props: true
    },
    {
      path: 'judges/:judgeId/categories',
      component: JudgeCategories,
      props: true
    },

    {
      path: 'judges/:judgeId/categories/group',
      component: CompositionsJudge,
      props: true
    },

    {
      path: 'users',
      component: UsersList
    },

    {
      path: 'users/:userId',
      component: UsersDetail,
      props: true
    },
    {
      path: 'datarequests',
      component: Organizations,
      meta: {
        title: 'Управление запросами',
      }
    },
    {
      path: 'datarequests/:orgId',
      name: 'OrgTemplate',
      component: OrgTemplate,
      props: true,
      meta: {
        title: 'Шаблоны запросов',
      }
    },
    {
      path: 'expert',
      name: 'ExpertPageRoute',
      component: ExpertPage,
      children: [
        {
          path: '',
          name: 'ExpertRegionsRoute',
          component: ExpertRegions,
        },
        {
          path: ':regionId',
          name: 'ExpertCourtsRoute',
          component: ExpertCourts,
          props: true
        }
      ]
    },
    {
      path: 'qrcode/logs',
      name: "QrCodeLogsRoute",
      component: QrCodeLogsPage
    }

  ]
}